import script from "./LiveTrainingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveTrainingSummary.vue?vue&type=script&setup=true&lang=js"

import "./LiveTrainingSummary.vue?vue&type=style&index=0&id=519a689b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519a689b"]])

export default __exports__